import {style} from 'typestyle'
import * as csstips from 'csstips'

export const SharePopWindow = style({
    width: '100%',
    height: '100%',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center
})

export const SharePopWindowMask = style({
    width: '100%',
    height: '100%',
    opacity: 0.5,
    background: '#000000',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 300
})

export const SharePopWindowWrap = style({
    width: 295,
    maxWidth: 480,
    background: '#FFFFFF',
    borderRadius: 12,
    paddingTop: 24,
    textAlign: 'center',
    zIndex: 301,
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    ...csstips.flexRoot,
    ...csstips.vertical,
    ...csstips.centerJustified,
    ...csstips.center,
    ...csstips.wrap,
    $nest: {
        '@media (max-width: 330px)': {
            width: 210
        }
    }
})

export const SharePopWindowTop = style({
    fontSize: 16,
    color: '#333333',
    ...csstips.flexRoot,
    ...csstips.vertical,
    ...csstips.centerJustified,
    ...csstips.center
})

export const SharePopWindowTopImg = style({
    width: 60,
    height: 60,
    borderRadius: '50%',
    margin: '0 auto 15px auto'
})

export const SharePopWindowMiddle = style({
    fontSize: 12,
    ...csstips.flexRoot,
    ...csstips.vertical,
    ...csstips.centerJustified,
    ...csstips.center,
    color: '#666666',
    margin: '15px 0'
})

export const SharePopWindowMiddleImgBox = style({
    width: 94,
    height: 94,
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
    padding: 2,
    margin: '0 auto 15px',
    $nest: {
        '& img': {
            width: '100%',
            margin: 0
        }
    }
})

export const SharePopWindowBottom = style({
    width: '100%',
    ...csstips.vertical
})

export const SharePopWindowBottomLine = style({
    width: '100%',
    borderTop: '1px solid #cccccc',
    transformOrigin: '0 0',
    transform: 'scaleY(0.5)'
})

export const SharePopWindowBottomText = style({
    height: 40,
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    fontSize: 14,
    color: 'green'
})



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/SharePopWindow/SharePopWindow.style.ts